import type { SerializedError } from '@reduxjs/toolkit';

import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const accessTokenJSON = localStorage.getItem('auth');

import initialConfig from '../initialConfig';

const initialState: {
  userMutationData: any;
  userMutationLoading: boolean;
  userMutationError: SerializedError | null;
} = {
  userMutationData: {},
  userMutationLoading: false,
  userMutationError: null,
};

export const userMutationFunc = createAsyncThunk(
  'userMutation/userMutationFunc',
  async (values: {
    updateUserInput: {
      contact: {
        address: {
          city: string;
          district: string;
          content: {
            title: string;
            description: string;
          };
          lat: 0;
          long: 0;
        };
        phoneNumber: null | string;
      };
      onboarded: boolean | null;
      personalInformation: {
        childAge: null | number;
        name: null | string;
        surname: null | string;
        fullName: null | string;
        profileImageUrl: null | string;
      };
    };
    userId: null;
  }) => {
    const data1 = JSON.stringify({
      query: `mutation UpdateUser($updateUserInput: UpdateUserInput!, $userId: ID) {
        updateUser(updateUserInput: $updateUserInput, userId: $userId) {
            _id
        }
    }`,
      variables: {
        updateUserInput: {
          contact: {
            address: {
              city: values.updateUserInput.contact.address.city,
              district: values.updateUserInput.contact.address.district,
              content: {
                title: values.updateUserInput.contact.address.content.title,
                description: values.updateUserInput.contact.address.content.description,
              },
              lat: values.updateUserInput.contact.address.lat,
              long: values.updateUserInput.contact.address.long,
            },
            phoneNumber: values.updateUserInput.contact.phoneNumber,
          },
          onboarded: values.updateUserInput.onboarded,
          personalInformation: {
            childAge: values.updateUserInput.personalInformation.childAge,
            name: values.updateUserInput.personalInformation.name,
            surname: values.updateUserInput.personalInformation.surname,
            fullName:
              values.updateUserInput.personalInformation.name +
              ' ' +
              values.updateUserInput.personalInformation.surname,
            profileImageUrl: values.updateUserInput.personalInformation.profileImageUrl,
          },
        },
        userId: values.userId,
      },
    });

    const config = initialConfig(
      process.env.REACT_APP_BASE_URL_USER || '',
      data1,
      accessTokenJSON ? JSON.parse(accessTokenJSON).accessToken : ''
    );

    const response = axios(config)
      .then((res) => {
        const data = res.data;
        return data;
      })
      .catch((err) => err);

    const data = await response;
    return data;
  }
);

const userMutation = createSlice({
  name: 'userMutation',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(userMutationFunc.pending, (state) => {
      state.userMutationLoading = true;
    });
    builder.addCase(userMutationFunc.fulfilled, (state, action) => {
      state.userMutationLoading = false;
      state.userMutationData = action.payload?.data?.userMutation;
      state.userMutationError = action.payload.errors || action.payload?.response?.status;
    });
    builder.addCase(userMutationFunc.rejected, (state, action) => {
      state.userMutationLoading = false;
      state.userMutationError = action.error;
    });
  },
});

export default userMutation.reducer;
